import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard  {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.loggedIn.pipe(
      map(
        authenticated =>
          authenticated ||
          this.router.createUrlTree(
            // if you want to change navigation if user is not authenticated
            route.data && route.data.authRedirect || ['auth', 'login']
          )
      )
    );
  }
}
